import "./DropdownMenu.scss";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    menu: {
        minWidth: '280px',
        color: theme.palette.secondary.muted2,
    },
}));

export default function DropdownMenu({ children, uid, open, onClose, buttonRef, popperPlacement = "bottom-end" }) {
    const classes = useStyles();

    return (
        <Popper 
            className="DropdownMenu"
            open={open} anchorEl={buttonRef.current} role={undefined} transition disablePortal
            placement={popperPlacement}
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement.indexOf('bottom') !== -1 ? 'center top' : 'center bottom' }}
                >
                    <Paper className="DropdownMenu__menucontainer">
                        <ClickAwayListener onClickAway={onClose}>
                            <MenuList autoFocusItem={open} id={uid} className={classes.menu}>
                                {children}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
}